import e from "../managers/braze-instance.js";
export function requestImmediateDataFlush(a) {
  e.rr() && e.mr().requestImmediateDataFlush(a);
}
